import FullWidthLayout from "@/layouts/FullWidthLayout";
import KTruckPreTripsTable from "kinnect-front/KYard/Trucks/KTruckPreTripsTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { getPreTrips } from "@/utils/http-calls";

export default {
	name: "YardTruckPreTripsPage",

	metaInfo: { title: "Yard - Trucks - Pre-Trips" },

	props: { idTruck: Number },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		preTrips: []
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_yard_pre_trips" ) ) {
				return {
					icon: "add_circle",
					text: "Add Pre-Trip",
					to: { name: "yardTruckPreTripAdd" },
					tooltip: "Add a new pre-trip"
				};
			}
		}
	},

	methods: {
		async fetchPreTrips() {
			this.preTrips = await getPreTrips( this.idTruck );
		},

		async fetch() {
			await this.fetchPreTrips();
		}
	},

	render() {
		return <FullWidthLayout>
			<KTruckPreTripsTable
				items={this.preTrips}
				loading={this.$wait.is( "getPreTrips" )}
			></KTruckPreTripsTable>
		</FullWidthLayout>;
	}
};
